module.exports = __webpack_public_path__ + "media/directory/topic_icon-582e4add.svg";